// code executed on create and edit pages
$(document).ready(/\/faculty-management\/ordering-article\/([0-9]+\/)?article\/([0-9]+\/)?(create|edit)/
    .test(window.location.pathname)&&function() {
  const priceType = $('[name="priceType"]');
  const netPrice = $('[name="netPrice"]');
  const vat = $('[name="valueAddedTax"]');
  const grossPrice = $('[name="grossPrice"]');

  const disableInput = function(element) {
    element.parent().addClass('disabled');
    element.prop('disabled', true);
    element.next().addClass('disabled');
    element.next().attr('aria-disabled', 'true');
  };
  const enableInput = function(element) {
    element.parent().removeClass('disabled');
    element.prop('disabled', false);
    element.next().removeClass('disabled');
    element.next().removeAttr('aria-disabled');
  };

  const togglePriceInput = function() {
    enableInput(vat);
    if (priceType.prop('checked') === true) {
      disableInput(grossPrice);
      enableInput(netPrice);
    } else {
      disableInput(netPrice);
      enableInput(grossPrice);
    }
  };

  const localeStringConfig = {maximumFractionDigits: 2, minimumFractionDigits: 2, useGrouping: false};

  const updateNetPrice = function() {
    const grossValue = Number(grossPrice.val().replace(/,/, '.'));
    const result = grossValue / (1 + Number(vat.val()) / 100);
    netPrice.val(Number(Math.round(Number(result + 'e+' + 2)) + 'e-' + 2)
        .toLocaleString(undefined, localeStringConfig));
  };

  const updateGrossPrice = function() {
    const netValue = Number(netPrice.val().replace(/,/, '.'));
    const result = netValue * (1 + Number(vat.val()) / 100);
    grossPrice.val(Number(Math.round(Number(result + 'e+' + 2)) + 'e-' + 2)
        .toLocaleString(undefined, localeStringConfig));
  };

  priceType.on('change', () => togglePriceInput());
  vat.on('input', () => grossPrice.prop('disabled') ? updateGrossPrice() : updateNetPrice());
  netPrice.on('input', () => updateGrossPrice());
  grossPrice.on('input', () => updateNetPrice());

  // submit prices with point as decimal separator
  $('form').on('submit', function() {
    netPrice.val(netPrice.val().replace(/,/, '.'));
    grossPrice.val(grossPrice.val().replace(/,/, '.'));
  });
});
